import { Storage } from "./storage";
import { STORAGE_NAMES } from "./storageNames";

export const AuthStorage = {
  setAccessToken(token: string) {
    return Storage.setItem(STORAGE_NAMES.ACCESS_TOKEN, token);
  },
  getAccessToken() {
    return Storage.getItem(STORAGE_NAMES.ACCESS_TOKEN);
  },

  setRefreshToken(token: string) {
    return Storage.setItem(STORAGE_NAMES.REFRESH_TOKEN, token);
  },
  getRefreshToken() {
    return Storage.getItem(STORAGE_NAMES.REFRESH_TOKEN);
  },

  clearTokens() {
    Storage.removeItem(STORAGE_NAMES.ACCESS_TOKEN);
    Storage.removeItem(STORAGE_NAMES.REFRESH_TOKEN);
  },
};
